// extracted by mini-css-extract-plugin
module.exports = {"motec":"motec","shouldShow":"shouldShow","speed":"speed","rpm":"rpm","rpmBar":"rpmBar","rpmOptimum":"rpmOptimum","gear":"gear","rmpMaxed":"rmpMaxed"};